import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { fixedArea } from '../../../shared/styles/fixedArea.vanilla.mjs';
import { useSingleSelectContext } from '../../contexts/context.mjs';

const SingleSelectContentFooter = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { onContentFooterElementChange } = useSingleSelectContext("ContentFooter");
  const className = classNames(
    fixedArea({ side: "bottom" }),
    classNameFromProps
  );
  const composedRef = useComposedRefs(
    forwardedRef,
    (element) => onContentFooterElementChange(element)
  );
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "single-select",
      "data-part": "content-footer",
      className,
      ref: composedRef,
      ...props
    }
  );
});

export { SingleSelectContentFooter as SelectContentFooter };
//# sourceMappingURL=ContentFooter.mjs.map
